<template lang="pug">
    v-form.c-form(autocomplete="off" @submit.prevent="submit")
        // Code field
        v-text-field(
          name="code"
          :label="$t('fields.code')"
          v-model="code"
          v-validate="{ required: true, min: 4, max: 4}"
          :data-vv-as="$t('fields.code')"
          :error-messages="errors.collect('code')"
          outline
        )

        div.controls.mt-4
            div
                // Resend code
                button-component.ml-0.resend(
                    outline
                    color="white"
                    size="medium"
                    :action="resend"
                    :isLoading="isLoading"
                ) {{ $t('fields.resendCode') }}

            div

                // Submit button
                button-component.mr-0.submit(
                    type="submit"
                    color="primary"
                    size="medium"
                    :action="submit"
                    :isLoading="isLoading"
                ) {{ $t('auth.registration.confirm') }}

        separator-component

        // Message
        div {{ $t('auth.confirmEmail.messageBottom') }}
</template>

<script>
    import Button from '~components/Button';
    import Separator from '~components/Separator';
    import CodeInput from 'vue-verification-code-input';
    import { mapActions, mapGetters } from 'vuex';
    import VueTypes from 'vue-types';

    export default {
        components: {
            ButtonComponent: Button,
            SeparatorComponent: Separator,
            CodeInput
        },
        props: {
            email: VueTypes.string.def(''),
            userType: VueTypes.string.def('')
        },
        data() {
            return {
                code: null,
                resendCode: this.$route.query.resend || false
            };
        },
        computed: {
            ...mapGetters('auth', ['isLoading'])
        },
        mounted() {
            if (this.resendCode) {
                this.resend();
            }
        },
        methods: {
            ...mapActions('auth', ['confirmEmail', 'resendEmail']),

            /**
             * Change password and login user on submit
             */
            async submit() {
                this.confirmEmail({
                    email: this.email,
                    code: this.code,
                    type: this.type
                });
            },

            resend() {
                this.resendEmail(this.email);
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../../assets/style/_variables.styl"

    .controls
        display: flex
        justify-content: space-between
        align-items: center
        flex-direction: row

        div
            width: auto

    .inputWrapper
        width: 100% !important
        display: flex
        align-items: center
        flex-direction: row
        justify-content: center
</style>
